import { environment } from '../environments/environment';

export function getBaseLocation() {
  const userAgent = navigator.userAgent;
  if (userAgent.indexOf('AndroidPortalApp') !== -1 || userAgent.indexOf('iOSPortalApp') !== -1) {
    return '';
  } else {
    if (window.location.hostname === 'localhost') {
      return '';
    } else {
      return '' + environment.applicationRoot + '/';
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/app-common-functions.ts